import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import { generateTokensCSS, updateTokenRegistry } from 'designSystem/tokens/resolver';

// Component to inject design system tokens as CSS custom properties into the document
// This enables the browser to resolve var() references in style tokens
export const TokenStylesInjector = () => {
	const designSystemContent = useSelector((r: RootReducer) => r.mode.designSystemContent);

	useEffect(() => {
		// Combine theme and styles tokens - theme tokens MUST come first
		// so that styles tokens can reference them via var()
		const themeTokens = designSystemContent?.theme?.all || [];
		const stylesTokens = designSystemContent?.styles?.tokens?.all || [];

		// Important: Theme tokens must be defined before styles tokens
		// because styles tokens contain var() references to theme tokens
		const allTokens = [...themeTokens, ...stylesTokens];

		if (allTokens.length === 0) {
			return;
		}

		// Update the token registry for resolution
		updateTokenRegistry(allTokens);

		// Generate CSS from tokens
		const cssContent = generateTokensCSS(allTokens);

		// Find or create style element for design system tokens
		let styleElement = document.getElementById('design-system-tokens') as HTMLStyleElement;
		if (!styleElement) {
			styleElement = document.createElement('style');
			styleElement.id = 'design-system-tokens';
			document.head.appendChild(styleElement);
		}

		// Update the CSS content
		styleElement.textContent = cssContent;
	}, [designSystemContent?.theme?.all, designSystemContent?.styles?.tokens?.all]);

	return null;
};
